module.exports = __webpack_public_path__ + "img/Sara_Circle_mobile-03.6c65f799.png";